import { VBase } from "./VBase";

const defaultOptions = {
  map: null,
  color: 0xffffff,
  opacity: 1,
  width: 0.2,
  height: 0.2,
  radius: 0.01,
};

/*
  使用案例

   // 加载一张图片并创建VImage
    this.manager.loadManager
        .loadTexture("/assets/imgs/displacement.png")
        .then((tex) => {
          let image = this.uiLib.createImage({
            map: tex,
            width: 0.5,
            height: 0.5,
            radius: 0.05,
          });
          this.uiLib.addUIToScene(image);
        });


*/

export class VImage extends VBase {
  /**
   * options:
   * {
   *      priority: 优先级，默认为1，值越小越靠前
   *      renderOrder: 渲染顺序，默认为99999
   *      map: 图片，非地址
   *      color: 图片颜色，默认为0xffffff
   *      opacity: 透明度，默认为1，不透明
   *      width: 按钮宽度，默认为 0.2
   *      height: 按钮高度，默认为 0.2
   *      radius: 圆角半径，设为0则是矩形，默认为0.01
   * }
   * @param {*} options
   */
  constructor(options, vuiLib) {
    if (!options) options = {};

    const tempOptions = {
      priority: options.priority !== undefined ? options.priority : 1,
      renderOrder:
        options.renderOrder !== undefined ? options.renderOrder : 99999,
      map: options.map ? options.map : defaultOptions.map,
      color: options.color !== undefined ? options.color : defaultOptions.color,
      opacity:
        options.opacity !== undefined
          ? options.opacity
          : defaultOptions.opacity,
      width: options.width !== undefined ? options.width : defaultOptions.width,
      height:
        options.height !== undefined ? options.height : defaultOptions.height,
      radius:
        options.radius !== undefined ? options.radius : defaultOptions.radius,
    };

    super(tempOptions, vuiLib);
    this._vType = "VImage";

    this.name = "VImage";
  }

  // 此对象不需要点击交互
  getClickable() {
    return [];
  }
}
